import React from "react";

export const ClientDashboardAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: "/client/dashboard",
      component: React.lazy(() => import("./ClientDashboardApp")),
    },
  ],
};
